import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class RegisterStripeVendorCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IRegisterStripeVendorParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'vendor/stripe';
  public override setParameters(parameters: IRegisterStripeVendorParameters) {
    this._commandBody = parameters;
  }
}

export interface IRegisterStripeVendorParameters extends ICommandParameters {
  userId: string;
  code: string;
}
